import { makeStyles } from "@material-ui/styles";

const teamStyles = makeStyles((theme) => ({
	avatar: {
		width: ({ size }) => (size === "small" ? 20 : 40),
		height: ({ size }) => (size === "small" ? 20 : 40),
		fontSize: ({ size }) => (size === "small" ? ".7em" : "inherit")
	},
	team: {
		display: "inline-flex",
		alignItems: "center"
	},
	teamName: {
		marginLeft: 10,
		fontWeight: ({ isWinner }) => (isWinner ? "bold" : "normal")
	},
	incompleteStatus: {
		fontSize: "0.6rem",
		fontWeight: "bold",
		color: theme.palette.primary.main
	},
	chipSquared: {
		borderRadius: 1
	}
}));

export default teamStyles;
